import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Project from './pages/Project';
import Services from './pages/Services';
import Work from './pages/Work';
import CustomServices from './pages/CustomServices';
import Contact from './pages/Contact';
import MoreProjects from './pages/MoreProjects';
import Careers from './pages/Careers';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Project />} />
        <Route path="/services" element={<Services />} />
        <Route path="/work" element={<Work />} />
        <Route path="/custom-services" element={<CustomServices />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/more-projects" element={<MoreProjects />} />
        <Route path="/careers" element={<Careers />} />
      </Routes>
    </Router>
  );
}

export default App;